"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Container = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  position: fixed !important;\n  top: 0 !important;\n  left: 0 !important;\n  width: 100vw !important;\n  height: 100vh !important;\n  justify-content: center;\n  align-items: center;\n  flex: 1;\n  z-index: 9999999999999999999999;\n  overflow: hidden;\n  background: ", ";\n  ", "\n"])), function (_ref) {
  var background = _ref.background;
  return background || 'transparent';
}, function (_ref2) {
  var $bsStyle = _ref2.$bsStyle;
  return $bsStyle || '';
});
exports.Container = Container;